import { useEffect } from 'react'
import { cn } from '../utils/cn'

export default function CardDepoimento({
  key_2,
  depoimento,
  autor,
  cargo,
  image,
  evaluetion,
  expanded,
  funcExpanded,
  isMobile,
  cardIndex,
  activeIndex,
}) {
  const key = Math.random()

  const listStars = []
  for (let i = 0; i < evaluetion; i++) {
    listStars.push(
      <img width={24} key={Math.random()} src="../assets/star.svg" alt="" />,
    )
  }

  const isActiveCard = isMobile && cardIndex === activeIndex

  function expand() {
    if (!isMobile) {
      const cardElement = document.getElementById('card' + key)
      const depoimentoElement = document.getElementById('depoimento_' + key)
      const starsSuperiorElement = document.getElementById(
        'StarsSuperior_' + key,
      )
      const starsInferiorElement = document.getElementById(
        'StarsInferior_' + key,
      )
      const continuarLendoElement = document.getElementById(
        'continuarLendo_' + key,
      )

      if (cardElement) {
        cardElement.classList.remove('grow-0')
        cardElement.classList.add('grow')
      }
      if (depoimentoElement) {
        depoimentoElement.classList.remove('textCardDepoimentoMin')
        depoimentoElement.classList.add('textCardDepoimentoMax')
      }
      if (starsSuperiorElement) {
        starsSuperiorElement.classList.remove('hidden')
        starsSuperiorElement.classList.add('flex')
      }
      if (starsInferiorElement) {
        starsInferiorElement.classList.remove('flex')
        starsInferiorElement.classList.add('hidden')
      }
      if (continuarLendoElement) {
        continuarLendoElement.classList.remove('flex')
        continuarLendoElement.classList.add('hidden')
      }
    }
  }

  function contract() {
    if (!isMobile) {
      const cardElement = document.getElementById('card' + key)
      const depoimentoElement = document.getElementById('depoimento_' + key)
      const starsSuperiorElement = document.getElementById(
        'StarsSuperior_' + key,
      )
      const starsInferiorElement = document.getElementById(
        'StarsInferior_' + key,
      )
      const continuarLendoElement = document.getElementById(
        'continuarLendo_' + key,
      )

      if (cardElement) {
        cardElement.classList.remove('grow')
        cardElement.classList.add('grow-0')
      }
      if (depoimentoElement) {
        depoimentoElement.classList.remove('textCardDepoimentoMax')
        depoimentoElement.classList.add('textCardDepoimentoMin')
      }
      if (starsSuperiorElement) {
        starsSuperiorElement.classList.remove('flex')
        starsSuperiorElement.classList.add('hidden')
      }
      if (starsInferiorElement) {
        starsInferiorElement.classList.remove('hidden')
        starsInferiorElement.classList.add('flex')
      }
      if (continuarLendoElement) {
        continuarLendoElement.classList.remove('hidden')
        continuarLendoElement.classList.add('block')
      }
    }
  }

  useEffect(() => {
    if (expanded) {
      expand()
    } else {
      contract()
    }
  }, [expanded])

  return !isMobile ? (
    <div
      id={'card' + key}
      onClick={() => {
        if (!expanded) {
          funcExpanded(key_2)
        }
      }}
      className={`w-[350px] h-[400px] rounded-[20px] p-8 duration-200 flex flex-col justify-between ${expanded ? 'bg-white' : 'bg-[#1D1A2D] hover:bg-gradient-to-b hover:from-[#403E4E] hover:to-[#1D1A2D] cursor-pointer'}`}
    >
      <div>
        <div className="flex flex-row gap-4">
          <img
            className="object-scale-down"
            src={
              expanded
                ? '../assets/aspas_duplas.svg'
                : '../assets/aspas_duplas_white.svg'
            }
            alt=""
          />
          <div
            id={'StarsSuperior_' + key}
            className=" flex-row justify-center gap-2 "
          >
            {listStars}
          </div>
        </div>

        <p
          id={'depoimento_' + key}
          className={`font-roboto text-base mt-5 w-full ${expanded ? 'text-black' : 'text-white'}`}
        >
          {depoimento}
        </p>
        <p
          onClick={e => {
            e.stopPropagation()
            funcExpanded(key_2)
          }}
          id={'continuarLendo_' + key}
          className="text-[#4B3BDB] underline decoration-1 cursor-pointer"
        >
          continuar lendo
        </p>

        <div
          id={'StarsInferior_' + key}
          className="flex-row mt-7 justify-center gap-2"
        >
          {listStars}
        </div>
      </div>

      <div className="flex flex-row gap-3 mt-5 ">
        <div className="min-w-[50px]">
          <img
            className="w-[50px] object-scale-down rounded-full border-gray-400 border-solid border-4"
            src={image}
            alt=""
          />
        </div>

        <div>
          <h3
            className={`font-raleway_bold text-base ${expanded ? 'text-black' : 'text-white'}`}
          >
            {autor}
          </h3>
          <p
            className={`font-raleway text-base ${expanded ? 'text-black' : 'text-white'}`}
          >
            {cargo}
          </p>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={cn(
        'rounded-lg p-8 w-[80%] h-full flex flex-col justify-between',
        isActiveCard
          ? 'bg-white'
          : 'bg-gradient-to-b from-[rgba(64,62,78)] via-[#373644] to-[rgba(45,43,59)] text-white',
      )}
    >
      <div className="flex flex-col h-full">
        <div className="w-[220px] mt-4 flex flex-row items-center gap-3">
          <div>
            {isActiveCard && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="15"
                fill="none"
                viewBox="0 0 19 15"
              >
                <title>Aspas duplas</title>
                <path
                  fill="#333"
                  fillOpacity="0.8"
                  d="M7.203.55 5.969 7.394h2.243v7.571H.641V7.281L2.66.55zm10.543 0-1.233 6.843h2.243v7.571h-7.571V7.281L13.204.55z"
                />
              </svg>
            )}
            {!isActiveCard && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="15"
                fill="none"
                viewBox="0 0 19 15"
              >
                <title>Aspas duplas</title>
                <path
                  fill="#fff"
                  fillOpacity="0.8"
                  d="M7.203.55 5.969 7.394h2.243v7.571H.641V7.281L2.66.55zm10.543 0-1.233 6.843h2.243v7.571h-7.571V7.281L13.204.55z"
                />
              </svg>
            )}
          </div>
          {isActiveCard && (
            <div className="flex flex-row gap-1">{listStars}</div>
          )}
        </div>

        <p className="font-roboto text-xs mt-5 w-full">{depoimento}</p>

        <div className="flex-grow" />
      </div>

      {!isActiveCard && (
        <div className="flex flex-row justify-left my-4 gap-2">{listStars}</div>
      )}

      <div className="flex flex-row gap-3">
        <div className="min-w-[32px]">
          <img
            className="w-[32px] object-scale-down rounded-full border-gray-400 border-solid border-2"
            src={image}
            alt=""
          />
        </div>
        <div>
          <h3 className="font-raleway_bold text-xs">{autor}</h3>
          <p className="font-raleway text-xs">{cargo}</p>
        </div>
      </div>
    </div>
  )
}
